
import axios from "axios";
import  { getMsalInstance,getMsalInProgress } from "./msalService"


const BASEURL = process.env.REACT_APP_BACKEND_API_URL;
const httpInterceptor = axios.create({
  baseURL: BASEURL,
});
httpInterceptor.interceptors.request.use(
    async (request) => {
          const instance = getMsalInstance();
          const inProgress = getMsalInProgress();
       
            if (instance && inProgress === "none") {
              const accounts = instance.getAllAccounts();
              const accessTokenRequest = {
                scopes: [`${process.env.REACT_APP_AZURE_CLIENT_ID}/.default`],
                account: accounts[0],
                };
                    await instance.acquireTokenSilent(accessTokenRequest)
                    .then((accessTokenResponse) => {
                        let accessToken = accessTokenResponse.accessToken;
                        if (accessToken) { // if access token is present, add it to the bearer-token
                                request.headers["access_token"] = `Bearer ${accessToken}`;
                                //request.headers["email"] =  instance.getActiveAccount().username;
                            }
                        }
                  
                      );
                    }
  
      return request;
    },
  
    (error) => { // Error-handling
      console.error("Request error ::", error);
      return Promise.reject(error);
      
    }
  );

  httpInterceptor.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response) {
        if (error.response && error.response.status === 403) {
          window.location.href = "/403";
        }
        return Promise.reject(error);
    } else {
        // Network or other error
        return Promise.reject(error);
    }
      
    }
  )
  export default httpInterceptor;